import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-services6',
  templateUrl: './section-services6.component.html',
  styleUrls: ['./section-services6.component.css']
})
export class SectionServices6Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
